// API configuration - central single source for admin
const PRODUCTION_BASE = 'https://api.yuanchengchuzu.cn'

// 获取 API 基础地址
export function getAPIBaseURL(): string {
  if (typeof window !== 'undefined') {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    return isLocal ? 'http://localhost:3000' : PRODUCTION_BASE
  }
  return PRODUCTION_BASE
}

// 获取API接口地址
export function getAPIURL(): string {
  return `${getAPIBaseURL()}/api`
}

// 获取图片完整 URL
// imagePath: 图片路径
// size: 尺寸参数（100, 200 等）
// skipPNG: 是否跳过 PNG 格式（默认 true，用于 logo 场景）
export function getImageURL(imagePath: string, size?: number, skipPNG: boolean = true): string {
  if (!imagePath) return ''

  // 构建基础 URL
  let url: string
  if (imagePath.startsWith('http')) {
    url = imagePath
  } else {
    url = `${getAPIBaseURL()}${imagePath}`
  }

  // 如果是 JPG/JPEG/WEBP 图片，添加尺寸参数
  if (url.includes('.jpg') || url.includes('.jpeg') || url.includes('.webp')) {
    // 如果已经有尺寸参数，不再添加
    if (!url.match(/_[0-9]+$/)) {
      const suffix = size ? `_${size}` : '_100'
      return url + suffix
    }
  }

  // 如果是 PNG 图片，且 skipPNG 为 false，也添加尺寸参数
  if (!skipPNG && url.includes('.png')) {
    // 如果已经有尺寸参数，不再添加
    if (!url.match(/_[0-9]+$/)) {
      const suffix = size ? `_${size}` : '_100'
      return url + suffix
    }
  }

  return url
}

// 获取小图 URL（用于列表）
export function getThumbURL(imagePath: string, skipPNG: boolean = true): string {
  return getImageURL(imagePath, 100, skipPNG)
}

// 获取中图 URL（用于弹窗/详情）
export function getMediumURL(imagePath: string, skipPNG: boolean = true): string {
  return getImageURL(imagePath, 200, skipPNG)
}
